import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Events from './pages/Events';
import ContactUs from './pages/ContactUs';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { EventProvider } from './context/EventContext_supabase';
import './styles/App.css';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      // Use localStorage for admin status
      const adminStatus = localStorage.getItem('isAdmin') === 'true';
      setIsAdmin(adminStatus);
    } catch (error) {
      console.error('Failed to check admin status:', error);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  const handleAdminLogin = async () => {
    try {
      setIsAdmin(true);
      localStorage.setItem('isAdmin', 'true');
    } catch (error) {
      console.error('Failed to save admin status:', error);
      localStorage.setItem('isAdmin', 'true');
    }
  };

  const handleAdminLogout = async () => {
    try {
      setIsAdmin(false);
      localStorage.removeItem('isAdmin');
    } catch (error) {
      console.error('Failed to clear admin status:', error);
      localStorage.removeItem('isAdmin');
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#0a0a0a',
        color: '#00ff80'
      }}>
        <div>Loading Vibrate LA...</div>
      </div>
    );
  }

  return (
    <EventProvider>
      <Router>
        <div className="App">
          <Header isAdmin={isAdmin} onLogout={handleAdminLogout} />
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/admin/login" element={
              isAdmin ? 
              <Navigate to="/admin/dashboard" replace /> : 
              <AdminLogin onLogin={handleAdminLogin} />
            } />
            <Route path="/admin/dashboard" element={
              isAdmin ? 
              <AdminDashboard /> : 
              <Navigate to="/admin/login" replace />
            } />
          </Routes>
          <Footer />
        </div>
      </Router>
    </EventProvider>
  );
}

export default App;
